import { z } from "zod"


export const loginSchema = z.object({
  email: z.string().min(3, "Please enter your email"),
  password: z.string().min(6, "Password must be at least 6 characters"),
})

// export const registerSchema = z.object({
//   username: z.string().min(3, "Username must be at least 3 characters"),
//   email: z.string().email("Please enter a valid email address"),
//   password: z.string().min(6, "Password must be at least 6 characters"),
//   countryCode: z.string().optional(),
//   phoneNumber: z.string().min(8, "Please enter a valid phone number"),
// })
export const registerSchema = z.object({
  firstName: z.string().min(2, "First name must have at least 2 characters."),
  lastName: z.string().min(2, "Last name must have at least 2 characters."),
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z.string().min(8, "Confirm password is required"),
  city: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Please select a city from the dropdown",
  }),
  googleRating: z.string().optional(),
  googlePlaceId: z.string().optional(),
  countryCode: z.string(),

  phoneNumber: z.string(),
  fullPhoneNumber: z.string(),
  dailyInspiration: z.boolean(),
}).refine((data) => data.password === data.confirmPassword, {
  path: ["confirmPassword"],
  message: "Password and confirm password do not match",
});

const normalizeUrl = (url) => {
  if (!url || url.trim() === '') return '';

  let normalizedUrl = url.trim();

  // Check if URL already has a protocol
  if (!/^https?:\/\//i.test(normalizedUrl)) {
    // Remove www. temporarily if it exists to avoid duplication
    const hasWww = normalizedUrl.startsWith('www.');

    // Add https:// protocol
    normalizedUrl = `https://${normalizedUrl}`;
  }

  return normalizedUrl;
};


export const businessBasicRegisterSchema = z.object({
  businessName: z.string().min(2, "Business name must have at least 2 characters."),
  city: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Please select a city from the dropdown",
  }),
  cityTitle: z.string().optional(),

  businessCategory: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Selected category is Invalid",
  }),
  businessSubCategory: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Selected category is Invalid",
  }),
  businessSubCategory: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Selected category is Invalid",
  }),
  businessSubCategoryTitle: z.string().optional(),
});

export const businessRegisterSchema = z.object({
  firstName: z.string().min(2, "First name must have at least 2 characters."),
  lastName: z.string().min(2, "Last name must have at least 2 characters."),
  businessName: z.string().min(2, "Business name must have at least 2 characters."),
  email: z.string().email("Invalid business email address"),
  city: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Please select a city from the dropdown",
  }),
  phoneNumber: z.string().min(6, "Phone number is required"),
  countryCode: z.string(),
  businessCategory: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Selected category is Invalid",
  }),
  businessSubCategory: z.string().regex(/^[0-9a-fA-F]{24}$/, {
    message: "Selected category is Invalid",
  }),
  address: z.string().min(5, "Address must be at least 5 characters"),
  googlePlaceId: z.string().optional(),
  googleRating: z.number().optional(),
  // googleRating: z.optional(),
  websiteLink: z
    .string()
    .url("Enter a valid website URL")
    .or(z.literal("")) // allow empty string
    .optional(),
  websiteLink: z
    .string()
    .trim()
    .optional()
    .or(z.literal(""))
    .refine(
      (value) => {
        if (!value) return true;
        const pattern =
          /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
        return pattern.test(value);
      },
      { message: "Please enter a valid website URL" }
    ),
  password: z.string().min(8, "Password must be at least 8 characters"),
  confirmPassword: z.string().min(8, "Confirm password is required"),
}).refine((data) => {
  // Only enforce when referralProfessional is provided
  if (!data.referralProfessional) return true;
  return data.email.trim().toLowerCase() !== data.referralProfessional.trim().toLowerCase();
}, {
  path: ["referralProfessional"],
  message: "Referral email must be different from business email",
});